import { Dialog } from '@factorialco/f0-react/dist/experimental'
import { Cross } from '@factorialco/f0-react/icons/app'
import {
  AtsVacanciesCancelVacanciesDocument,
  AtsVacanciesTableDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  vacancyIds: string[]
  onClose: () => void
  onSuccess: () => void
}

export const CancelVacanciesDialog = ({ vacancyIds, onClose, onSuccess }: Props) => {
  const [cancelVacancies, { loading, client }] = useMutation(AtsVacanciesCancelVacanciesDocument, {
    extractorFn: (result) => result.atsMutations.bulkCancelAtsVacancy,
  })

  const handleCancel = async () => {
    const result = await cancelVacancies({
      variables: {
        ids: vacancyIds,
      },
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ats.vacancies.cancel_vacancy_dialog.error_message'),
      })
    })

    if (handled.success) {
      void client.refetchQueries({ include: [AtsVacanciesTableDocument] })

      app.setFlash({
        type: 'correct',
        message: i18n.t('ats.vacancies.cancel_vacancy_dialog.success_message'),
      })
      onSuccess()
    }
  }

  return (
    <Dialog
      open
      onClose={onClose}
      header={{
        type: 'critical',
        title: i18n.t('ats.vacancies.cancel_vacancy_dialog.title'),
        description: i18n.t('ats.vacancies.cancel_vacancy_dialog.description'),
      }}
      actions={{
        primary: {
          icon: Cross,
          label: i18n.t('ats.vacancies.cancel_vacancy_dialog.confirm_button'),
          onClick: handleCancel,
          variant: 'critical',
          disabled: loading,
        },
        secondary: {
          label: i18n.t('ats.vacancies.cancel_vacancy_dialog.go_back_button'),
          onClick: onClose,
        },
      }}
    />
  )
}
